/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { NavLink } from "react-router-dom";

// @mui/material components
import { makeStyles } from "@mui/styles";
import { List, ListItem, Button } from "@mui/material";

import { useAuth0 } from "./react-auth0-wrapper.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export function HeaderLink(props) {
  const classes = useStyles();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          className={classes.navLink}
          component={NavLink}
          to={props.href}
          style={{
            marginTop: "3px",
            padding: "10px 15px 10px 15px",
          }}
        >
          {props.linkText}
        </Button>
      </ListItem>
    </List>
  );
}

export function HeaderLinksLeft(props) {
  const { isAuthenticated } = useAuth0();
  return (
    <React.Fragment>
      <HeaderLink linkText="Home" href="/home" />
      <HeaderLink linkText="API Documentation" href="/apidoc/overview" />
      {isAuthenticated && <HeaderLink linkText="My Apps" href="/myapps" />}
    </React.Fragment>
  );
}

export function HeaderLinksRight() {
  const classes = useStyles();
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        {!isAuthenticated && (
          <HeaderLink linkText="Sign Up/Log In" href="/myapps" />
        )}

        {isAuthenticated && (
          <Button
            onClick={() =>
              logout({
                returnTo: `${location.protocol}//${location.host}/home`,
              })
            }
            className={classes.navLink}
            style={{
              marginTop: "3px",
              padding: "10px 15px 10px 15px",
            }}
          >
            Log Out
          </Button>
        )}
      </ListItem>
    </List>
  );
}
